import { CheckOutService } from './../../services/checkout.service';
import { Component, OnInit, HostBinding, Inject, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MyAccountService } from '../../services/myAccount.service';
import { StateModel, CompanyInfoViewModel, CurrentUserModel, UpdatedCompanyInfoViewModel } from '../../models/account-ledger.model';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { CommonService } from '../../services/common.service';
import { Router, NavigationEnd } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress } from 'ngx-progressbar';
import { AuthService } from '../../services/auth.service';
import { DOCUMENT } from '@angular/common';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { PostcodeList, SuburbList } from '../../models/account-delivery-address';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, skip, takeUntil } from 'rxjs/operators'
import { NgProgressService } from '../../services/ngProgress.service';

@Component({
    selector: 'app-company-information',
    templateUrl: './company-information.component.html',
    styleUrls: ['./company-information.component.css'],
})
export class CompanyInformationComponent implements OnInit, OnDestroy {
    closeResult: string;
    title = 'Company Information';
    companyInfo: CompanyInfoViewModel;
    companyForm: FormGroup;
    resMsg: string;
    postcodeNumber: number;
    postcodeString: string;
    statePopulated: string;
    sendCompanyinfo: CompanyInfoViewModel = {
        companyName: '',
        addressLine: '',
        addressLine2: '',
        suburb: '',
        state: '',
        postcode: '',
        phone: '',
        status: '',
        statusDescription: '',
        accountCode: '',
        mainContact: '',
        abn: '',
        emailAddress: '',
        website: '',
        message: ''
    };
    updatedCompanyInfo: UpdatedCompanyInfoViewModel = {
        in_accountcode: '',
        in_resell_ecom: '',
        in_resell_var: '',
        in_resell_isv: '',
        in_resell_si: '',
        in_resell_msp: '',
        in_resell_retail: '',
        in_target_ict: '',
        in_target_construct: '',
        in_target_edu: '',
        in_target_agri: '',
        in_target_health: '',
        in_target_legal: '',
        in_target_gov: '',
        in_target_finance: '',
        in_target_manufacture: '',
        in_target_consumer: '',
        in_target_mining: '',
        in_target_rental: '',
        in_target_arts: '',
        in_max_target: '',
        in_min_target: '',
        in_email: '',
        in_phone: '',
        in_website: '',
        in_twitter: '',
        in_facebook: '',
        in_linkedin: ''
    };
    currentCompanyInfo: any;
    stateList: string[];
    combinedAddress: string;
    modalRef: NgbModalRef;
    loadContent = false;
    accountId: string;
    primaryFocus: string;
    filteredSub: PostcodeList[];
    filteredPostCode: PostcodeList[];

    companyInfoForm = this.formBuilder.group({
        email: ['', this.commonService.emailValidatorRegex()],
        linkedin: [''],
        phone: [''],
        facebook: [''],
        website: [''],
        twitter: [''],
        business: this.formBuilder.group({
            ecom: { value: '', disabled: false },
            isv: { value: '', disabled: false },
            msp: { value: '', disabled: false },
            retail: { value: '', disabled: false },
            si: { value: '', disabled: false },
            var: { value: '', disabled: false },
        }),
        primaryFocus: '',
        endUserEverageSize: '',
        primaryTarget: this.formBuilder.group({
            agricultureForestryAndFishing: '',
            consumer: '',
            education: '',
            governmentAndDefence: '',
            informationAndCommunicationTechnology: '',
            manufacturing: '',
            rentalHiringRealEstateServices: '',
            artsAndRecreation: '',
            constructionAndEngineering: '',
            financeAndInsurance: '',
            healthcareAndMedical: '',
            legal: '',
            miningAndResources: '',
        })
    });
    ngUnsubscribe: Subject<void> = new Subject<void>();
    @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
    @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
    constructor(
        private formBuilder: FormBuilder,
        private shoppingCartService: ShoppingCartService,
        private myAccountService: MyAccountService,
        private commonService: CommonService,
        private router: Router,
        private modalService: NgbModal,
        private ngProgress: NgProgressService,
        private authService: AuthService,
        private checkOutService: CheckOutService,
        @Inject(DOCUMENT) private _document: Document
    ) {
    }

    ngOnInit(): void {
        this.ngProgress.start();
        this.shoppingCartService.getState().subscribe((res: StateModel) => {
            this.stateList = res.states;
        },
            (error: any) => {
                console.error(error);
            });

        this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
            this.accountId = res.accountId;
        });

        this.myAccountService.getDebtOrDetails().subscribe((res) => {
            this.currentCompanyInfo = res;
            const endUserMinSize = this.currentCompanyInfo.out_min_target;
            let endUserEverageSize;
            switch (endUserMinSize) {
                case '0':
                    endUserEverageSize = '0-250';
                    break;
                case '250':
                    endUserEverageSize = '250-2000';
                    break;
                case '2000':
                    endUserEverageSize = '2000+';
            }

            let updatedPrimaryFocus;
            const primaryFocusItems = {
                ecom: this.currentCompanyInfo.out_resell_ecom,
                isv: this.currentCompanyInfo.out_resell_isv,
                msp: this.currentCompanyInfo.out_resell_msp,
                retail: this.currentCompanyInfo.out_resell_retail,
                out_resell_si: this.currentCompanyInfo.out_resell_si,
                out_resell_var: this.currentCompanyInfo.out_resell_var
            };

            Object.entries(primaryFocusItems).forEach(function ([key, value]) {
                if (value === '9') {
                    updatedPrimaryFocus = key;
                }
            });
            this.primaryFocus = updatedPrimaryFocus;
            this.companyInfoForm.patchValue({
                email: this.currentCompanyInfo.out_email,
                linkedin: this.currentCompanyInfo.out_linkedin,
                phone: this.currentCompanyInfo.out_phone,
                facebook: this.currentCompanyInfo.out_facebook,
                website: this.currentCompanyInfo.out_website,
                twitter: this.currentCompanyInfo.out_twitter,
                business: {
                    ecom: { value: this.currentCompanyInfo.out_resell_ecom === '0' ? false : true, disabled: false },
                    isv: { value: this.currentCompanyInfo.out_resell_isv === '0' ? false : true, disabled: false },
                    msp: { value: this.currentCompanyInfo.out_resell_msp === '0' ? false : true, disabled: false },
                    retail: { value: this.currentCompanyInfo.out_resell_retail === '0' ? false : true, disabled: false },
                    si: { value: this.currentCompanyInfo.out_resell_si === '0' ? false : true, disabled: false },
                    var: { value: this.currentCompanyInfo.out_resell_var === '0' ? false : true, disabled: false },
                },
                primaryFocus: updatedPrimaryFocus,
                endUserEverageSize: endUserEverageSize,
                primaryTarget: {
                    agricultureForestryAndFishing: this.currentCompanyInfo.out_target_agri === '0' ? false : true,
                    consumer: this.currentCompanyInfo.out_target_consumer === '0' ? false : true,
                    education: this.currentCompanyInfo.out_target_edu === '0' ? false : true,
                    governmentAndDefence: this.currentCompanyInfo.out_target_gov === '0' ? false : true,
                    informationAndCommunicationTechnology: this.currentCompanyInfo.out_target_ict === '0' ? false : true,
                    manufacturing: this.currentCompanyInfo.out_target_manufacture === '0' ? false : true,
                    rentalHiringRealEstateServices: this.currentCompanyInfo.out_target_rental === '0' ? false : true,
                    artsAndRecreation: this.currentCompanyInfo.out_target_arts === '0' ? false : true,
                    constructionAndEngineering: this.currentCompanyInfo.out_target_construct === '0' ? false : true,
                    financeAndInsurance: this.currentCompanyInfo.out_target_finance === '0' ? false : true,
                    healthcareAndMedical: this.currentCompanyInfo.out_target_health === '0' ? false : true,
                    legal: this.currentCompanyInfo.out_target_legal === '0' ? false : true,
                    miningAndResources: this.currentCompanyInfo.out_target_mining === '0' ? false : true,
                }
            });
            if (updatedPrimaryFocus) {
                this.companyInfoForm.get('business').get(updatedPrimaryFocus).setValue({ disabled: true });
            }
        });
        this.ngProgress.done();

        this.companyForm = this.formBuilder.group({
            companyName: ['', Validators.required],
            mainContact: ['', Validators.required],
            addressLine: ['', Validators.required],
            addressLine2: [''],
            suburb: ['', Validators.required],
            state: ['', Validators.required],
            postcode: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
            // phone: ['',[Validators.required, Validators.maxLength(15)]],

            // newly required fields
            // abn: ['',Validators.required],
            message: ['']
        });

        // this.myAccountService.getCompanyProfile().subscribe((data: CompanyInfoViewModel) => {
        this.myAccountService.companyProfile$.asObservable().pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: CompanyInfoViewModel) => {
            if (data) {
                let addressLine: string;
                this.companyInfo = data;
                // console.log(data);
                if (data.addressLine && !data.addressLine2) {
                    addressLine = `${data.addressLine}, `;
                } else if (data.addressLine2 && !data.addressLine) {
                    addressLine = `${data.addressLine2}`;
                } else if (data.addressLine2 && data.addressLine) {
                    addressLine = `${data.addressLine},${data.addressLine2},`;
                } else {
                    addressLine = '';
                }

                this.combinedAddress = `${addressLine}${data.suburb},${data.state},${data.postcode}`;
                for (const key in this.companyInfo) {
                    if (this.companyInfo[key]) {
                        this.companyInfo[key] = this.companyInfo[key].toLowerCase();
                    }
                }
                // this.companyForm.setValue(this.companyInfo);
                this.setDefaultCompanyInfo();
            }
        },
            (error: any) => {
                console.error(error);
            });
    }

    setDefaultCompanyInfo() {
        this.companyForm.get('companyName').setValue(this.companyInfo.companyName);
        this.companyForm.get('mainContact').setValue(this.companyInfo.mainContact);
        this.companyForm.get('addressLine').setValue(this.companyInfo.addressLine);
        this.companyForm.get('addressLine2').setValue(this.companyInfo.addressLine2);
        this.companyForm.get('suburb').setValue(this.companyInfo.suburb);
        this.companyForm.get('postcode').setValue(this.companyInfo.postcode);
        this.companyForm.get('state').setValue(this.companyInfo.state);
        // this.companyForm.get('phone').setValue(this.companyInfo.phone);
        // this.companyForm.get('abn').setValue(this.companyInfo.abn);
        this.companyForm.get('message').setValue('');
    }

    openVerticallyCentered(content) {
        this.modalRef = this.modalService.open(content, { centered: true });
        this.modalRef.result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    isFieldValid(field: string): boolean {
        this.postcodeNumber = Number(this.companyForm.get('postcode').value);
        this.postcodeString = this.companyForm.get('postcode').value;
        this.populateStateByPostcode(this.postcodeNumber, this.postcodeString);
        return !this.companyForm.get(field).valid && this.companyForm.get(field).touched;
    }

    populateStateByPostcode(postcodeInputNum: number, postcodeStr: string): void {
        if (postcodeInputNum >= 1000 && postcodeInputNum <= 2599 || postcodeInputNum >= 2619 && postcodeInputNum <= 2899 || postcodeInputNum >= 2921 && postcodeInputNum <= 2999) {
            this.statePopulated = 'NSW';
        } else if (postcodeStr.substring(0, 2) === '02' || postcodeInputNum >= 2600 && postcodeInputNum <= 2618 || postcodeInputNum >= 2900 && postcodeInputNum <= 2920) {
            this.statePopulated = 'ACT';
        } else if (postcodeInputNum >= 3000 && postcodeInputNum <= 3999 || postcodeInputNum >= 8000 && postcodeInputNum <= 8999) {
            this.statePopulated = 'VIC';
        } else if (postcodeInputNum >= 4000 && postcodeInputNum <= 4999 || postcodeInputNum >= 9000 && postcodeInputNum <= 9999) {
            this.statePopulated = 'QLD';
        } else if (postcodeInputNum >= 5000 && postcodeInputNum <= 5999) {
            this.statePopulated = 'SA';
        } else if (postcodeInputNum >= 6000 && postcodeInputNum <= 6999) {
            this.statePopulated = 'WA';
        } else if (postcodeInputNum >= 7000 && postcodeInputNum <= 7999) {
            this.statePopulated = 'NSW';
        } else if (postcodeStr.substring(0, 2) === '09' || postcodeStr.substring(0, 2) === '08') {
            this.statePopulated = 'NT';
        } else {
            this.statePopulated = '';
        }

        this.companyForm.patchValue({
            state: this.statePopulated
        });
    }

    displayFieldCss(field: string) {
        return {
            'error-wrapper': this.isFieldValid(field),
        };
    }

    submitToAccounts = () => {

        let isStateInvalidOnly: boolean = true;

        for (const field in this.companyForm.controls) {
            if (this.companyForm.controls[field].invalid && field !== 'state') {
                isStateInvalidOnly = false;
                break;
            }
        }

        if (this.companyForm.valid || isStateInvalidOnly) {

            this.sendCompanyinfo.companyName = this.companyForm.get('companyName').value.toString().toUpperCase();
            this.sendCompanyinfo.mainContact = this.companyForm.get('mainContact').value.toString().toUpperCase();
            this.sendCompanyinfo.addressLine = this.companyForm.get('addressLine').value.toString().toUpperCase();
            this.sendCompanyinfo.addressLine2 = this.companyForm.get('addressLine2').value.toString().toUpperCase();
            this.sendCompanyinfo.suburb = this.companyForm.get('suburb').value.toString().toUpperCase();
            this.sendCompanyinfo.postcode = this.companyForm.get('postcode').value.toString().toUpperCase();
            this.sendCompanyinfo.state = this.companyForm.get('state').value.toString().toUpperCase();
            // this.sendCompanyinfo.phone = this.companyForm.get('phone').value.toString().toUpperCase();
            // this.sendCompanyinfo.abn = this.companyForm.get('abn').value.toString().toUpperCase();
            this.sendCompanyinfo.message = this.companyForm.get('message').value.toString();
            //console.log(this.sendCompanyinfo);

            // sending data to the backend
            this.myAccountService.updateCompanyProfile(this.sendCompanyinfo).subscribe(
                (data: any) => {
                    this.resMsg = data.responseMessage;
                    this.commonService.showResult('#submit-companyInfo-button', this.resMsg, 'left', 3000);
                    setTimeout(() => {
                        this.modalRef.close();
                        this.setDefaultCompanyInfo();
                        this.markFormGroupUntouched(this.companyForm);
                    }, 4000);
                },
                error => {
                    this.resMsg = error.responseMessage;
                    this.commonService.showResult('#submit-companyInfo-button', this.resMsg, 'left', 3000);
                    setTimeout(() => {
                        this.modalRef.close();
                        this.setDefaultCompanyInfo();
                        this.markFormGroupUntouched(this.companyForm);
                    }, 4000);
                },
            );
        } else {
            this.validateAllFormFields(this.companyForm);
        }
    }

    markFormGroupUntouched(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsUntouched({ onlySelf: true });
            }
        });
    }

    validateAllFormFields(formGroup: FormGroup): void {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    tickItemForBusiness(event) {
        const previousPrimaryFocus = this.primaryFocus;
        this.companyInfoForm.get('business').get(event.value).setValue({ value: true, disabled: true });
        if (this.primaryFocus) {
            this.companyInfoForm.get('business').get(previousPrimaryFocus).setValue({ value: true, disabled: false });
        }
        this.primaryFocus = this.companyInfoForm.value.primaryFocus;
    }

    saveCompanyInfo() {
        if (this.companyInfoForm.controls.email.valid === true) {


            this.updatedCompanyInfo.in_accountcode = this.accountId;
            this.updatedCompanyInfo.in_resell_ecom = (this.companyInfoForm.value.business.ecom === true || this.companyInfoForm.value.business.ecom.value === true) ? '1' : '0';
            this.updatedCompanyInfo.in_resell_var = (this.companyInfoForm.value.business.var === true || this.companyInfoForm.value.business.var.value === true) ? '1' : '0';
            this.updatedCompanyInfo.in_resell_isv = (this.companyInfoForm.value.business.isv === true || this.companyInfoForm.value.business.isv.value === true) ? '1' : '0';
            this.updatedCompanyInfo.in_resell_si = (this.companyInfoForm.value.business.si === true || this.companyInfoForm.value.business.si.value === true) ? '1' : '0';
            this.updatedCompanyInfo.in_resell_msp = (this.companyInfoForm.value.business.msp === true || this.companyInfoForm.value.business.msp.value === true) ? '1' : '0';
            this.updatedCompanyInfo.in_resell_retail = (this.companyInfoForm.value.business.retail === true || this.companyInfoForm.value.business.retail.value === true) ? '1' : '0';
            this.updatedCompanyInfo.in_target_ict = this.companyInfoForm.value.primaryTarget.informationAndCommunicationTechnology === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_construct = this.companyInfoForm.value.primaryTarget.constructionAndEngineering === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_edu = this.companyInfoForm.value.primaryTarget.education === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_agri = this.companyInfoForm.value.primaryTarget.agricultureForestryAndFishing === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_health = this.companyInfoForm.value.primaryTarget.healthcareAndMedical === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_legal = this.companyInfoForm.value.primaryTarget.legal === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_gov = this.companyInfoForm.value.primaryTarget.governmentAndDefence === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_finance = this.companyInfoForm.value.primaryTarget.financeAndInsurance === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_manufacture = this.companyInfoForm.value.primaryTarget.manufacturing === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_consumer = this.companyInfoForm.value.primaryTarget.consumer === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_mining = this.companyInfoForm.value.primaryTarget.miningAndResources === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_rental = this.companyInfoForm.value.primaryTarget.rentalHiringRealEstateServices === true ? '1' : '0';
            this.updatedCompanyInfo.in_target_arts = this.companyInfoForm.value.primaryTarget.artsAndRecreation === true ? '1' : '0';
            if (this.companyInfoForm.value.endUserEverageSize === '0-250') {
                this.updatedCompanyInfo.in_max_target = '250';
                this.updatedCompanyInfo.in_min_target = '0';
            } else if (this.companyInfoForm.value.endUserEverageSize === '250-2000') {
                this.updatedCompanyInfo.in_max_target = '2000';
                this.updatedCompanyInfo.in_min_target = '250';
            } else if (this.companyInfoForm.value.endUserEverageSize === '2000+') {
                this.updatedCompanyInfo.in_max_target = '9999';
                this.updatedCompanyInfo.in_min_target = '2000';
            }
            this.updatedCompanyInfo.in_email = this.companyInfoForm.value.email;
            this.updatedCompanyInfo.in_phone = this.companyInfoForm.value.phone;
            this.updatedCompanyInfo.in_website = this.companyInfoForm.value.website;
            this.updatedCompanyInfo.in_twitter = this.companyInfoForm.value.twitter;
            this.updatedCompanyInfo.in_facebook = this.companyInfoForm.value.facebook;
            this.updatedCompanyInfo.in_linkedin = this.companyInfoForm.value.linkedin;

            if (this.companyInfoForm.value.primaryFocus !== undefined) {
                let primaryFocusValue = this.companyInfoForm.value.primaryFocus;
                primaryFocusValue = 'in_resell_' + primaryFocusValue;
                this.updatedCompanyInfo[primaryFocusValue] = '9';
            }
            this.myAccountService.updateDebtorDetails(this.updatedCompanyInfo).subscribe((res: any) => {
                if (res.out_result_status === '0000') {
                    this.commonService.implementToast('Company information updated successfully.', 'Success');
                } else {
                    this.commonService.implementToast('Company information failed to update, please contact IT team for help.', 'Error');
                }
            },
                (error: any) => {
                    this.commonService.implementToast('Company information failed to update, please contact IT team for help.', 'Error');
                });

        } else {
            this.commonService.implementToast('Please input the correct Email', 'Error');
        }
        console.log(this.companyInfoForm);
    }

    isNumberKey(event: any) {
        const pattern = /[0-9\+\-\ ]/;
        const inputChar = String.fromCharCode(event.charCode);

        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    }

    noSpace(event) {
        const pattern = /^[^\s]*$/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    close() {
        this.router.navigateByUrl('/myAccount');
        this.markFormGroupUntouched(this.companyForm);
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }

    onInputSub(event: any): any {
        const target = event.currentTarget as HTMLInputElement;
        if (this._document.activeElement !== target) {
            this._myAutocompleteTriggerSub._onChange(target.value);
        }
    }

    onInputPostcode(event: any): any {
        const target = event.currentTarget as HTMLInputElement;
        if (this._document.activeElement !== target) {
            this._myAutocompleteTriggerPostcode._onChange(target.value);
        }
    }

    chooseAutoCompletSuburb(event: any): void {
        if (this.filteredSub) {
            this.companyForm.get('postcode').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
            this.companyForm.get('state').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
            this.companyForm.get('suburb').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
        }
    }

    // startFilterSub(): void {
    //     if (this.companyForm.get('suburb').value.length > 2) {
    //         this.checkOutService.getSuburbList(this.companyForm.get('suburb').value).subscribe((res: SuburbList[]) => {
    //             this.filteredSub = res;
    //         },
    //             (error: any) => {
    //                 console.error(error);
    //                 this.loadContent = true;
    //             });
    //     }
    // }

    // startFilterPostcode(): void {
    //     if (this.companyForm.get('postcode').value.length > 1) {
    //         this.checkOutService.getPostCodeList(this.companyForm.get('postcode').value).subscribe((res: SuburbList[]) => {
    //             this.filteredPostCode = res;
    //         },
    //             (error: any) => {
    //                 console.error(error);
    //                 this.loadContent = true;
    //             });
    //     }
    // }

    startFilterSub(res: PostcodeList[]): void {
        this.filteredSub = res;
    }

    startFilterPostcode(res: PostcodeList[]): void {
        this.filteredPostCode = res;

    }

    chooseAutoComplete(option: PostcodeList): void {
        this.companyForm.get('postcode').setValue(option.postcode);
        this.companyForm.get('state').setValue(option.state);
        this.companyForm.get('suburb').setValue(option.suburb);
    }

    chooseAutoCompletPostcode(event: any): void {
        if (this.filteredPostCode) {
            this.companyForm.get('postcode').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
            this.companyForm.get('state').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
            this.companyForm.get('suburb').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
        }
    }


    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
